export default __webpack_public_path__ + "static/media/nst_example.d436278c.png";